import React from "react";
import {
  EventStatus,
  IMaxOdd,
  oddsFormats,
  IOdds,
} from "../../utils/types";
import {bemNames} from "../../utils/bemnames";
import {baseSportsIndexDomain} from "../../utils/request";
import {formatOdds} from "../../utils/odds";
import {generateCdnProxyImageUrl} from "../../utils/helpers";
import ImgWithDefault from "../ImgWithDefault";

const bem = bemNames.create('button-with-operator');

interface IProps {
  oddItem?: IMaxOdd,
  oddsData?: IOdds,
  eventStatus: string | undefined,
  oddsFormat: oddsFormats,
  bigButton?: boolean
}

const OddsButtonWithOperatorOnly: React.FC<IProps> = (props) => {
  const {oddItem, eventStatus, oddsFormat, oddsData, bigButton = false} = props;

  return (
    <div className={`
      ${oddItem?.oddsPrev && eventStatus === EventStatus.Inprogress ? bem.e('odds-moving') : ''}
      ${oddsData?.oddsPrev && eventStatus === EventStatus.Inprogress ? bem.e('odds-moving') : ''}
      ${bigButton ? bem.e('big-button') : bem.b('')}
    `}>
      {oddItem && oddItem.provider && oddItem.provider.squareLogoUrl && (
        <div className={` ${bem.m('provider')}`}>
          <ImgWithDefault
            src={generateCdnProxyImageUrl(`${baseSportsIndexDomain}${oddItem.provider.squareLogoUrl ?? oddItem.provider.lightLogoUrl}`)}
            alt={oddItem.provider.name}
          />
        </div>
      )}

      {oddsData && oddsData.provider && oddsData.provider.squareLogoUrl && (
        <div className={` ${bem.e('big-button--provider')}`}>
          <ImgWithDefault
            src={generateCdnProxyImageUrl(`${baseSportsIndexDomain}${oddsData.provider.squareLogoUrl ?? oddsData.provider.lightLogoUrl}`)}
            alt={oddsData.provider.name}
          />
        </div>
      )}

      {oddItem && (
        <div className={` ${bem.m('odds')}`}>
          {formatOdds((oddItem.odds), oddsFormat)}
          {
            oddItem && oddItem.oddsPrev && oddItem.odds && (oddItem.oddsPrev < oddItem.odds ?
              (<div className={bem.m('odds--drifting')}>▲</div>) :
              (<div className={bem.m('odds--shortening')}>▼</div>))
          }
        </div>
      )}

      {oddsData && (
        <div className={` ${bem.e('big-button--odds')}`}>
          {formatOdds((oddsData.odds), oddsFormat)}
          {(oddsData && oddsData.oddsPrev && oddsData.odds) &&
            ((oddsData.oddsPrev < oddsData.odds) ?
                (<div className={bem.e('big-button--odds--drifting')}>▲</div>) :
                (<div className={bem.e('big-button--odds--shortening')}>▼</div>)
            )
          }
        </div>
      )}
    </div>
  );
}

export default OddsButtonWithOperatorOnly;
